import {BrowserRouter, Route, Routes} from "react-router-dom";
import {type ReactNode, Suspense} from "react";

import {PreloaderContainer} from "./styles";
import {useAppInit} from "../lib/hooks/useAppInit";
import {LogoSvg} from "shared/ui/logoSvg";
import {routes} from "./config";
import {TitleSync} from "./TitleSync";
import {Layout} from "widgets/Layout";
import {AdminRedirect, AuthRedirect} from "shared/lib/guards";
import {CookieConsentPopup} from 'features/cookieConsent';

const Fallback = () => (
	<PreloaderContainer>
		<LogoSvg />
	</PreloaderContainer>
);

const AppInit = ({ children }: { children: ReactNode }) => {
	const isInit = useAppInit();
	if (!isInit && window.location.pathname !== "/login") {
		return <Fallback />;
	}
	return <>{children}</>;
};

const withLayout = routes.filter(r => !r.noLayout);
const withoutLayout = routes.filter(r => r.noLayout);

export const AppRouter = () => {
	return (
		<BrowserRouter>
			<AppInit>
				<TitleSync />
				<CookieConsentPopup />

				<Routes>
					{/* Ветка с Layout */}
					<Route element={<Layout />}>
						{withLayout.map((r, i) => {
							const Element = r.element;
              let cnt = <Element />
              if (r.adminOnly) {
                cnt = <AdminRedirect>{cnt}</AdminRedirect>
              }
							const content = (
								<Suspense fallback={<Fallback />}>
									{cnt}
								</Suspense>
							);
							return <Route key={`in-${i}`} path={r.path} element={content} />;
						})}
					</Route>

					{/* Ветка без Layout (login/registration) */}
					{withoutLayout.map((r, i) => {
						const Element = r.element;
						let content = <Element />;

						if (r.guestOnly) {
							content = <AuthRedirect>{content}</AuthRedirect>;
						}

						return (
							<Route
								key={`out-${i}`}
								path={r.path}
								element={
									<Suspense fallback={<Fallback />}>
										{content}
									</Suspense>
								}
							/>
						);
					})}
				</Routes>
			</AppInit>
		</BrowserRouter>
	);
};
